var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('OtherDialog',{attrs:{"showMask":_vm.showMask,"dialogName":_vm.popType,"extra":_vm.dialogExtra},on:{"click-close":_vm.clickClose,"click-confirm":function($event){return _vm.clickConfirm(arguments, _vm.popType)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }